const BASE = process.env.REACT_APP_API_URL || '/api';

const req = async (method, path, body, token) => {
  const res = await fetch(BASE + path, {
    method,
    headers: Object.assign({'Content-Type':'application/json'}, token ? {Authorization:'Bearer '+token} : {}),
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro desconhecido');
  return data;
};

export const api = {
  get:   (path, token)       => req('GET',    path, null, token),
  post:  (path, body, token) => req('POST',   path, body, token),
  put:   (path, body, token) => req('PUT',    path, body, token),
  patch: (path, body, token) => req('PATCH',  path, body, token),
  del:   (path, token)       => req('DELETE', path, null, token),
};
